import * as React from 'react';
import ContentModal from '../components/content-modal';
import CreateReportIcon from '../../assets/images/create-report-icon.png';
import styled from 'styled-components/native';
import SelectParameterCategory from '../../components/csic/select-parameter-category';
import config from './config';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function SelectParameterCategoryScreen() {
  return (
    <Screen title="Select Layer" icon={CreateReportIcon}>
      <SelectParameterCategory />
    </Screen>
  );
}
